import { get2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { RecommendCategory } from "@/shared/utils/interfaces";
import { useQuery } from "@tanstack/react-query";

const useRecommendedProductQuery = (
  minSupportPercentage: number,
  minConfidencePercentage: number
) => {
  const branch = useBranchId();

  return useQuery<RecommendCategory[]>({
    queryKey: [
      "recommended-product",
      branch,
      minSupportPercentage,
      minConfidencePercentage,
    ],
    queryFn: () =>
      get2(
        `internal/secure/pos/v1/menus/recommended-products-suggestion/${branch}/${minSupportPercentage}/${minConfidencePercentage}`
      ),
    enabled: branch !== undefined,
    refetchOnMount: false,
  });
};

export default useRecommendedProductQuery;
